import React, { useState, useEffect, useRef } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import { useNavigate } from 'react-router-dom';
import "slick-carousel/slick/slick-theme.css";
import { uploadAllAssets } from "../../utils/CloudinaryUploadManager";
import { doc, setDoc, collection, addDoc, serverTimestamp } from "firebase/firestore";
import { db } from "../../firebase"; // Your Firebase configuration
// Add these imports at the top
import { query, where, getDocs, updateDoc, getDoc } from "firebase/firestore";
import { 
  FacebookShareButton, 
  TwitterShareButton, 
  WhatsappShareButton,
  FacebookIcon,
  TwitterIcon,
  WhatsappIcon,
  EmailShareButton,
  EmailIcon
} from "react-share";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";

const BG =
  "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756198334/image_1925_aurvx2.png";
const LOGO =
  "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759158128/image_2533_o6tz1g.png";
const ICON_CHEVRON =
  "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756235638/Expand_left_1_me5z46.png";
const WHATSAPP =
  "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756198332/image_1913_pbw7rg.png";
const ADD_ICON = "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759158499/Add_square_duotone_qxznya.png";
const EDIT_ICON = "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756301543/Edit_fill_abynwk.png";
const SAVE_ICON = "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759174773/Import_light_n3jgg0.png";
const DELETE_ICON = "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756301543/Trash_duotone_line_gtnuaq.png";
const DOWNLOAD_ICON = "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756543210/Download_duotone_line.png"; // Add this icon

const CONTENTS = [
  "CAKES",
  "MUFFINS",
  "COOKIES",
  "SCONES",
  "MAANDAZI",
  "MAHAMRI",
  "KAIMATI",
  "KITUMBUA",
  "SAMOSAS",
];

// Use the new default image for all thumbnails
const DEFAULT_THUMB = "https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759178422/Rectangle_34644226_ldcfkz.png";
const THUMBS = Array(6).fill(DEFAULT_THUMB);

function SplitButtonTop({ 
  label = "XXXXXXXX", 
  onTextChange, 
  isSaved,
  onSearch 
}) {
  const [text, setText] = useState(label);

  const handleChange = (e) => {
    setText(e.target.value);
    if (onTextChange) onTextChange(e.target.value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter' && onSearch) {
      onSearch();
    }
  };

  return (
    <div className="flex flex-col items-start">
      <div className="flex items-stretch h-[25px] md:h-[50px] select-none shadow-sm overflow-hidden rounded-lg">
        {/* Left dark segment (text) */}
        <span className="bg-[#25242C] text-white w-[100px] md:w-[250px] flex items-center justify-center text-[6px] md:text-[20px] font-bold tracking-wide">
          <input
            type="text"
            value={text}
            onChange={handleChange}
            onKeyPress={handleKeyPress}
            className="bg-transparent border-none outline-none text-center w-full"
            placeholder="Enter registration #"
          />
        </span>
        {/* Right yellow icon square - now acts as search button */}
        <button 
          className="w-[25px] md:w-[50px] h-[25px] md:h-[50px] bg-[#FDBB26] grid place-items-center"
          onClick={onSearch}
          disabled={!text.trim()}
        >
       <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756198332/Expand_down_igfdta.png"
            alt="expand"
            className="w-[20px] md:w-[25px] h-[25px] md:h-[31px] object-contain"
          />
        </button>
      </div>
      {!isSaved && (
        <div className="text-white text-[8px] md:text-[12px] mt-1">
          Enter your registration number or create a new one
        </div>
      )}
    </div>
  );
}

function SplitButtonBottom({ label = "Next", onSave, isSaved, onShare }) {
  return (
    <div className="flex flex-col items-end justify-end gap-2">
  
      <button
        className="flex items-stretch h-[25px] md:h-[50px] select-none shadow-sm overflow-hidden rounded-lg"
        aria-label={label}
        onClick={isSaved ? onShare : undefined}
      >
        {/* Left white icon box attached */}
        <span className="w-[20px] md:w-[55px] h-[25px] md:h-[50px] bg-[#2E453D] grid place-items-center">
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759174469/Expand_left_light_k7zo73.png"
            alt="expand"
            className="w-[20px] md:w-[25px] h-[20px] md:h-[31px] object-contain"
          />
        </span>
        {/* Right dark segment (text) */}
        <span
          className="bg-[#25242C] text-white w-[80px] md:w-[200px] flex items-center justify-center text-[8px] md:text-[20px] font-bold tracking-wide"
          style={{ lineHeight: "1" }}
        >
          {isSaved ? "Share Catalog" : label}
        </span>
        <span className="w-[20px] md:w-[50px] h-[25px] md:h-[50px] bg-[#FDBB26] grid place-items-center">
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1756198332/Expand_down_igfdta.png"
            alt="expand"
            className="w-[20px] md:w-[25px] h-[20px] md:h-[31px] object-contain"
          />
        </span>
      </button>
      {!isSaved && (
        <div className="flex items-center gap-1 cursor-pointer" onClick={onSave}>
          <img
            src={SAVE_ICON}
            alt="Save"
            className="w-[20px] h-[20px] md:w-[30px] md:h-[30px]"
          />
        </div>
      )}
    </div>
  );
}

function ShareModal({ isOpen, onClose, shareLink, businessName, onDownloadPDF }) {
  const [copied, setCopied] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  
  const copyToClipboard = () => {
    navigator.clipboard.writeText(shareLink).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(err => {
      console.error('Failed to copy: ', err);
      alert("Failed to copy link. Please try again.");
    });
  };

  // Professional message template
  const shareMessage = `Hello 👋, I'm excited to share my ${businessName} catalog with you! This collection represents my best work and offerings. Please take a moment to browse through it here: ${shareLink}. I'd love to hear your feedback! 📋✨`;

  const handleDownload = async () => {
    setIsDownloading(true);
    try {
      await onDownloadPDF();
    } catch (error) {
      console.error("PDF download failed:", error);
    } finally {
      setIsDownloading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl max-w-md w-full overflow-hidden shadow-xl">
        {/* Header with celebration emoji */}
        <div className="bg-gradient-to-r from-blue-950 to-blue-900 p-5 text-center">
          <div className="text-4xl mb-2">🎉</div>
          <h2 className="text-white text-xl font-bold">Catalog Saved Successfully!</h2>
          <p className="text-white opacity-90 mt-1">Share your catalog with customers</p>
        </div>
        
        <div className="p-5">
          <p className="text-gray-600 mb-4 text-center">
            Spread the word about your business by sharing your catalog
          </p>
          
          {/* Social sharing buttons */}
          <div className="flex justify-center space-x-4 mb-6">
            <WhatsappShareButton 
              url={shareLink} 
              title={shareMessage}
              className="flex flex-col items-center"
            >
              <WhatsappIcon size={48} round />
              <span className="text-xs mt-1">WhatsApp</span>
            </WhatsappShareButton>
            
            <FacebookShareButton 
              url={shareLink} 
              quote={shareMessage}
              className="flex flex-col items-center"
            >
              <FacebookIcon size={48} round />
              <span className="text-xs mt-1">Facebook</span>
            </FacebookShareButton>
            
            <TwitterShareButton 
              url={shareLink} 
              title={shareMessage}
              className="flex flex-col items-center"
            >
              <TwitterIcon size={48} round />
              <span className="text-xs mt-1">Twitter</span>
            </TwitterShareButton>
            
            <EmailShareButton 
              url={shareLink} 
              subject={`Check out my ${businessName} catalog`}
              body={shareMessage}
              className="flex flex-col items-center"
            >
              <EmailIcon size={48} round />
              <span className="text-xs mt-1">Email</span>
            </EmailShareButton>
          </div>
          
          {/* Link copy section */}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Or copy your catalog link:
            </label>
            <div className="flex">
              <input
                type="text"
                value={shareLink}
                readOnly
                className="flex-grow px-3 py-2 border border-gray-300 rounded-l text-sm"
              />
              <button
                onClick={copyToClipboard}
                className="bg-blue-950 text-white px-4 py-2 rounded-r hover:bg-blue-900 flex items-center transition-colors"
              >
                {copied ? (
                  <>
                    <span className="mr-1">✓</span> Copied!
                  </>
                ) : (
                  "Copy"
                )}
              </button>
            </div>
          </div>
          
     
          {/* PDF Download Button */}
          <div className="mb-4">
            <button
              onClick={handleDownload}
              disabled={isDownloading}
              className="w-full bg-green-600 text-white py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center"
            >
              {isDownloading ? (
                <>
                  <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-white mr-2"></div>
                  Generating PDF...
                </>
              ) : (
                <>
                <img
            src={SAVE_ICON}
            alt="Save"
            className="w-[20px] h-[20px] md:w-[30px] md:h-[30px]"
          />
                  Download Catalog as PDF
                </>
              )}
            </button>
          </div>
        </div>
        
        {/* Footer with close button */}
        <div className="bg-gray-100 px-5 py-3 flex justify-end">
          <button
            onClick={onClose}
            className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
}

export default function BakeryCatalogue() {
  const handleSearch = async () => {
    if (!regNumber.trim()) {
      alert("Please enter a registration number");
      return;
    }
    
    const docId = await fetchCatalogByRegNumber(regNumber);
    if (docId) {
      setCurrentDocId(docId);
      const catalogUrl = `${window.location.origin}/catalog/${docId}`;
      setCatalogUrl(catalogUrl);
      localStorage.setItem('currentCatalogDocId', docId);
      localStorage.setItem('userCatalogUrl', catalogUrl);
    }
  };

  function CatalogListModal({ isOpen, onClose, catalogs, onCatalogSelect, onNewCatalog }) {
    if (!isOpen) return null;
  
    return (
      <div className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50 p-4">
        <div className="bg-white rounded-2xl max-w-2xl w-full max-h-[80vh] overflow-hidden shadow-xl">
          {/* Header */}
          <div className="bg-gradient-to-r from-blue-950 to-blue-900 p-5 text-center">
            <h2 className="text-white text-xl font-bold">My Catalogs</h2>
            <p className="text-white opacity-90 mt-1">Select a catalog to view or edit</p>
          </div>
          
          <div className="p-5 max-h-[60vh] overflow-y-auto">
            {catalogs.length === 0 ? (
              <div className="text-center py-8">
                <p className="text-gray-600 mb-4">No saved catalogs found.</p>
                <button
                  onClick={onNewCatalog}
                  className="bg-blue-950 text-white px-6 py-2 rounded-lg hover:bg-blue-900 transition-colors"
                >
                  Create New Catalog
                </button>
              </div>
            ) : (
              <div className="space-y-3">
                {catalogs.map((catalog) => (
                  <div
                    key={catalog.id}
                    className="border border-gray-200 rounded-lg p-4 hover:bg-gray-50 cursor-pointer transition-colors"
                    onClick={() => onCatalogSelect(catalog.id)}
                  >
                    <div className="flex justify-between items-start">
                      <div>
                        <h3 className="font-bold text-lg text-gray-800">
                          {catalog.businessName || catalog.catalogueTitle}
                        </h3>
                        <p className="text-sm text-gray-600 mt-1">
                          {catalog.catalogueSubtitle}
                        </p>
                        <p className="text-xs text-gray-500 mt-2">
                          Last updated: {catalog.updatedAt?.toDate?.().toLocaleDateString() || 'Recently'}
                        </p>
                      </div>
                      <div className="text-right">
                        <span className="inline-block bg-green-100 text-green-800 text-xs px-2 py-1 rounded">
                          Active
                        </span>
                      </div>
                    </div>
                    <div className="mt-2">
                      <p className="text-xs text-blue-600 break-all">
                        URL: {catalog.shareUrl}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
          
          {/* Footer */}
          <div className="bg-gray-100 px-5 py-3 flex justify-between">
            <button
              onClick={onNewCatalog}
              className="bg-gray-300 text-gray-800 px-4 py-2 rounded-lg hover:bg-gray-400 transition-colors"
            >
              New Catalog
            </button>
            <button
              onClick={onClose}
              className="bg-blue-950 text-white px-4 py-2 rounded-lg hover:bg-blue-900 transition-colors"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  const [isMobile, setIsMobile] = useState(false);
  const [address, setAddress] = useState("1 World Street, City, Country");
  const [businessName, setBusinessName] = useState("Dallan Farm");
  const [isEditingProducts, setIsEditingProducts] = useState(false);
  const [isSaved, setIsSaved] = useState(false);
  const [products, setProducts] = useState(CONTENTS);
  const [backgroundImage, setBackgroundImage] = useState(null);
  const [thumbnails, setThumbnails] = useState(THUMBS);
  const [catalogueTitle, setCatalogueTitle] = useState("XXXXXXXXX");
  const [catalogueSubtitle, setCatalogueSubtitle] = useState("Catalogue");
  const [catalogueTagline, setCatalogueTagline] = useState("XXXXXXXXXXXXXXXXX");
  const [shareLink, setShareLink] = useState("");
  const [isShareModalOpen, setIsShareModalOpen] = useState(false);
  const [currentDocId, setCurrentDocId] = useState(null);
  const [regNumber, setRegNumber] = useState("");
  const [isLoadingExisting, setIsLoadingExisting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [hasChanges, setHasChanges] = useState(false);
  
  // Create a ref for the PDF generation
  const pdfRef = useRef();
  
  // Check if device is mobile
  useEffect(() => {
    const checkIsMobile = () => {
      setIsMobile(window.innerWidth < 768);
    };
    
    checkIsMobile();
    window.addEventListener('resize', checkIsMobile);
    
    return () => {
      window.removeEventListener('resize', checkIsMobile);
    };
  }, []);
  
  
  // Slick slider settings - updated to always autoplay and remove arrows
  const sliderSettings = {
    dots: isMobile,
    infinite: true,
    speed: 500,
    slidesToShow: isMobile ? 1 : 4,
    slidesToScroll: isMobile ? 1 : 4,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false, // Always hide arrows
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          arrows: false
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          dots: true,
          arrows: false
        }
      }
    ]
  };
  const [activeButton, setActiveButton] = useState(0);
  const [activeTab, setActiveTab] = useState("farmers");
  const [catalogUrl, setCatalogUrl] = useState("");
  const [userCatalogs, setUserCatalogs] = useState([]);
  const [showCatalogList, setShowCatalogList] = useState(false);
  
  // Add this useEffect to load user's catalogs on component mount
  useEffect(() => {
    loadUserCatalogs();
    checkForExistingCatalog();
  }, []);
  
  // Function to load all user catalogs
const loadUserCatalogs = async () => {
  try {
    const q = query(
      collection(db, "Catalog"),
      where("userId", "==", "user-id") // Replace with actual user ID
    );
    
    const querySnapshot = await getDocs(q);
    const catalogs = [];
    
    querySnapshot.forEach((doc) => {
      catalogs.push({
        id: doc.id,
        ...doc.data(),
        shareUrl: `${window.location.origin}/catalog/${doc.id}`
      });
    });
    
    setUserCatalogs(catalogs);
  } catch (error) {
    console.error("Error loading user catalogs:", error);
  }
};

// Check if there's an existing catalog in localStorage
const checkForExistingCatalog = () => {
  const savedDocId = localStorage.getItem('currentCatalogDocId');
  if (savedDocId) {
    fetchCatalogById(savedDocId);
  }
};

  const buttons = [
    { label: "Catalogues", path: "/catalogues" },
    { label: "Website", path: "/" },
    { label: "CRM", path: "/" },
    { label: "Simulator", path: "/" },
    { label: "-", path: "/" }, // You can update these paths as needed
    { label: "-", path: "/" },
    { label: "-", path: "/" },
  ];
  const handleProductEdit = () => {
    setIsEditingProducts(!isEditingProducts);
    setIsSaved(false); // Reset saved state when editing
    if (!isEditingProducts) {
      setProducts(products.map((item, index) => 
        index === 0 || index === products.length - 1 ? "XXXXXX" : item
      ));
    }
  };
  const navigate = useNavigate();
  const generateShareId = () => {
    return Math.random().toString(36).substring(2, 10) + Math.random().toString(36).substring(2, 10);
  };

  const saveCatalogToFirestore = async (catalogData, docId = null) => {
    try {
      setIsLoading(true);
      
      console.log('Starting catalog save process...');
      
      // Upload all assets to Cloudinary first
      let catalogDataWithCloudinaryUrls;
      try {
        console.log('Uploading assets to Cloudinary...');
        catalogDataWithCloudinaryUrls = await uploadAllAssets(catalogData, "user-id");
        console.log('Cloudinary upload completed:', catalogDataWithCloudinaryUrls);
      } catch (uploadError) {
        console.error('Cloudinary upload failed:', uploadError);
        throw new Error(`Failed to upload images: ${uploadError.message}`);
      }
      
      const finalDocId = docId || generateShareId();
      const timestamp = serverTimestamp();
      
      const catalogDataToSave = {
        // Text content
        address: catalogDataWithCloudinaryUrls.address,
        businessName: catalogDataWithCloudinaryUrls.businessName,
        products: catalogDataWithCloudinaryUrls.products,
        catalogueTitle: catalogDataWithCloudinaryUrls.catalogueTitle,
        catalogueSubtitle: catalogDataWithCloudinaryUrls.catalogueSubtitle,
        catalogueTagline: catalogDataWithCloudinaryUrls.catalogueTagline,
        cataloguePrice: catalogDataWithCloudinaryUrls.cataloguePrice,
        // Images - ensure these are Cloudinary URLs
        backgroundImage: catalogDataWithCloudinaryUrls.backgroundImage,
        thumbnails: catalogDataWithCloudinaryUrls.thumbnails,
        
        // Registration number (used for search)
        registrationNumber: catalogDataWithCloudinaryUrls.catalogueTitle,
        
        // Static images
        logo: LOGO,
        whatsappIcon: WHATSAPP,
        chevronIcon: ICON_CHEVRON,
        addIcon: ADD_ICON,
        editIcon: EDIT_ICON,
        saveIcon: SAVE_ICON,
        deleteIcon: DELETE_ICON,
        
        // Metadata
        updatedAt: timestamp,
        userId: "user-id", // Replace with actual user ID
      };
  
      // Add createdAt only for new documents
      if (!docId) {
        catalogDataToSave.createdAt = timestamp;
        catalogDataToSave.shareId = finalDocId;
      }
  
      // Save to Firestore
      console.log('Saving to Firestore with ID:', finalDocId);
      await setDoc(doc(db, "Catalog", finalDocId), catalogDataToSave, { merge: true });
      
      console.log("Catalog saved successfully with ID: ", finalDocId);
      return finalDocId;
    } catch (error) {
      console.error("Error saving catalog: ", error);
      throw error;
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleSave = async () => {
    try {
      if (!regNumber.trim() && !catalogueTitle.trim()) {
        alert("Please enter a registration number or catalogue title");
        return;
      }
  
      const catalogData = {
        address,
        businessName,
        products,
        backgroundImage,
        cataloguePrice,
        thumbnails,
        catalogueTitle: regNumber || catalogueTitle,
        catalogueSubtitle,
        catalogueTagline,
        userId: "user-id", // Replace with actual user ID
        lastAccessed: serverTimestamp(),
      };
      
      const savedDocId = await saveCatalogToFirestore(catalogData, currentDocId);
      setCurrentDocId(savedDocId);
      
      // Generate and set the catalog URL
      const catalogUrl = `${window.location.origin}/catalog/${savedDocId}`;
      setCatalogUrl(catalogUrl);
      setShareLink(catalogUrl);
      
      setIsSaved(true);
      setIsEditingProducts(false);
      setHasChanges(false);
      
      // Save to localStorage for persistence
      localStorage.setItem('currentCatalogDocId', savedDocId);
      localStorage.setItem('userCatalogUrl', catalogUrl);
      
      // Reload user catalogs to include the new one
      await loadUserCatalogs();
      
      alert("Catalog saved successfully!");
    } catch (error) {
      console.error("Failed to save catalog:", error);
      alert("Failed to save catalog. Please try again.");
    }
  };
  
  // Function to load a specific catalog
  const loadCatalog = async (docId) => {
    try {
      setIsLoading(true);
      const docRef = doc(db, "Catalog", docId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const catalogData = docSnap.data();
        await loadCatalogData(catalogData, docId);
        
        // Update the catalog's last accessed time
        await updateDoc(docRef, {
          lastAccessed: serverTimestamp()
        });
        
        setShowCatalogList(false);
      } else {
        alert("Catalog not found. It may have been deleted.");
      }
    } catch (error) {
      console.error("Error loading catalog:", error);
      alert("Error loading catalog. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };
  const [cataloguePrice, setCataloguePrice] = useState("50/kg");
  const handleNewCatalog = () => {
    setCurrentDocId(null);
    setRegNumber("");
    setAddress("1 World Street, City, Country");
    setBusinessName("Dallan Farm");
    setProducts(CONTENTS);
    setBackgroundImage(null);
    setThumbnails(THUMBS);
    setCatalogueTitle("XXXXXXXXX");
    setCatalogueSubtitle("Catalogue");
    setCatalogueTagline("XXXXXXXXXXXXXXXXX");
    setShareLink("");
    setCatalogUrl("");
    setIsSaved(false);
    setHasChanges(false);
    setShowCatalogList(false);
    
    localStorage.removeItem('currentCatalogDocId');
    localStorage.removeItem('userCatalogUrl');
  };

  const handleShare = () => {
    setIsShareModalOpen(true);
  };
  const updatedSplitButtonTop = (
    <SplitButtonTop 
      label={regNumber}
      onTextChange={(value) => {
        setRegNumber(value);
        setHasChanges(true);
      }}
      isSaved={isSaved}
      onSearch={handleSearch}
    />
  );

  // Add a new catalog button
  const newCatalogButton = (
    <button
      onClick={handleNewCatalog}
      className="flex items-center gap-2 px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600 transition-colors"
    >
      <img src={ADD_ICON} alt="New" className="w-4 h-4" />
      New Catalog
    </button>
  );

  // Update your save button to show save status
  const saveButton = (
    <SplitButtonBottom 
      onSave={handleSave} 
      isSaved={isSaved} 
      onShare={handleShare}
      label={hasChanges ? "Save Changes" : "Next"}
    />
  );
  const saveIndicator = (
    <div className={`text-sm ${hasChanges ? 'text-yellow-500' : 'text-green-500'}`}>
      {hasChanges ? 'Unsaved changes' : 'All changes saved'}
    </div>
  );

  
  const fetchCatalogByRegNumber = async (regNumber) => {
    try {
      setIsLoadingExisting(true);
      
      const q = query(
        collection(db, "Catalog"), 
        where("registrationNumber", "==", regNumber)
      );
      
      const querySnapshot = await getDocs(q);
      
      if (!querySnapshot.empty) {
        const docSnapshot = querySnapshot.docs[0];
        const docData = docSnapshot.data();
        const docId = docSnapshot.id;
        
        await loadCatalogData(docData, docId);
        return docId;
      } else {
        alert("No catalog found with this registration number. Create a new one.");
        return null;
      }
    } catch (error) {
      console.error("Error fetching catalog: ", error);
      alert("Error loading catalog. Please try again.");
      return null;
    } finally {
      setIsLoadingExisting(false);
    }
  };

  // Fetch catalog by document ID
  const fetchCatalogById = async (docId) => {
    try {
      setIsLoadingExisting(true);
      
      const docRef = doc(db, "Catalog", docId);
      const docSnap = await getDoc(docRef);
      
      if (docSnap.exists()) {
        const docData = docSnap.data();
        await loadCatalogData(docData, docId);
        return docId;
      } else {
        console.log("No catalog found with this ID");
        return null;
      }
    } catch (error) {
      console.error("Error fetching catalog by ID: ", error);
      return null;
    } finally {
      setIsLoadingExisting(false);
    }
  };

  // Unified function to load catalog data into state
  const loadCatalogData = async (docData, docId) => {
    // Update all states with the retrieved data
    setAddress(docData.address || "");
    setBusinessName(docData.businessName || "");
    setProducts(docData.products || CONTENTS);
    setBackgroundImage(docData.backgroundImage || null);
    setThumbnails(docData.thumbnails || THUMBS);
    setCatalogueTitle(docData.catalogueTitle || "");
    setCatalogueSubtitle(docData.catalogueSubtitle || "");
    setCatalogueTagline(docData.catalogueTagline || "");
    setRegNumber(docData.registrationNumber || docData.catalogueTitle || "");
    setCataloguePrice(docData.cataloguePrice || "50/kg");
  

    // Set the share link and current document ID
    setShareLink(`${window.location.origin}/catalog/${docId}`);
    setCurrentDocId(docId);
    
    // Save document ID to localStorage for persistence
    localStorage.setItem('currentCatalogDocId', docId);
    
    setIsSaved(true);
    setIsEditingProducts(false);
    setHasChanges(false);
    
    console.log("Catalog loaded successfully");
  };


  const handleProductChange = (index, value) => {
    const newProducts = [...products];
    newProducts[index] = value;
    setProducts(newProducts);
    setIsSaved(false); // Reset saved state when editing
  };

  const handleThumbnailUpload = (index, file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        const newThumbnails = [...thumbnails];
        newThumbnails[index] = e.target.result;
        setThumbnails(newThumbnails);
        setIsSaved(false); // Reset saved state when editing
      };
      reader.readAsDataURL(file);
    }
  };
  const renderButtonWithIcon = (text, bgColor, iconColor, isLarge = false) => {
    // Define color mappings
    const bgColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };
  
    const iconColorClasses = {
      "#152C24": "bg-[#152C24]",
      "#2E453D": "bg-[#2E453D]",
      "#FDBB26": "bg-[#FDBB26]",
    };
  
    return (
      <div className="flex items-center">
        {/* Button Text */}
        <div className={`${bgColorClasses[bgColor]} text-white md:text-[14px] text-[5px] px-2 md:px-4 ${
          isLarge ? "md:h-[45px] py-[3px]" : "md:h-[13px] py-[3px]"
        } md:rounded-l-md rounded-l-md font-bold md:w-[200px] whitespace-nowrap flex items-center h-full`}>
          {text}
        </div>
        
        {/* Desktop Icon (visible on md and up) */}
        <div className={`${iconColorClasses[iconColor]} hidden md:flex items-center md:py-4  justify-center md:w-[50px] md:h-[45px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759170145/Send_hor_fill_zejhkv.png"
            alt="Expand"
            className="w-[20px] h-[6px] md:h-[25px] md:w-[30px]  object-contain"
          />
        </div>
        
        {/* Mobile Icon (visible below md) */}
        <div className={`${iconColorClasses[iconColor]} md:hidden flex items-center justify-center w-[20px]  h-[14px] rounded-r-md`}>
          <img
            src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759170145/Send_hor_fill_zejhkv.png"
            alt="Expand"
            className="w-[20px] h-[6px]  object-contain"
          />
        </div>
      </div>
    );
  };
  const handleBackgroundUpload = (file) => {
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        setBackgroundImage(e.target.result);
        setIsSaved(false); // Reset saved state when editing
      };
      reader.readAsDataURL(file);
    }
  };

  const handleDelete = () => {
    // Implement delete functionality here
    console.log("Delete button clicked");
  };

  const generatePDF = async () => {
    try {
      // Hide the share modal if it's open
      const shareModal = document.querySelector('.fixed.inset-0.bg-black');
      if (shareModal) {
        shareModal.style.display = 'none';
      }
      
      // Capture the main content area only
      const element = document.querySelector('.min-h-screen');
      if (!element) return;
      
      // Store original styles to restore later
      const originalOverflow = document.body.style.overflow;
      const originalHeight = element.style.height;
      
      // Temporarily adjust styles for clean capture
      document.body.style.overflow = 'hidden';
      element.style.height = 'auto'; // Ensure natural height
      
      // Get the exact dimensions of your content
      const contentWidth = element.scrollWidth;
      const contentHeight = element.scrollHeight;
      
      const canvas = await html2canvas(element, {
        scale: 2, // Higher resolution
        useCORS: true,
        logging: false,
        backgroundColor: '#ffffff',
        scrollX: 0,
        scrollY: 0,
        width: contentWidth,
        height: contentHeight,
        windowWidth: contentWidth,
        windowHeight: contentHeight
      });
      
      // Restore original styles
      document.body.style.overflow = originalOverflow;
      element.style.height = originalHeight;
      
      // Show the share modal again if it was hidden
      if (shareModal) {
        shareModal.style.display = 'flex';
      }
      
      const imgData = canvas.toDataURL('image/png', 1.0);
      
      // Calculate dimensions in millimeters (jsPDF uses mm)
      const pxToMm = 0.264583; // Conversion factor from pixels to millimeters
      const pdfWidth = canvas.width * pxToMm;
      const pdfHeight = canvas.height * pxToMm;
      
      // Create PDF with exact dimensions of your content
      const pdf = new jsPDF({
        orientation: pdfWidth > pdfHeight ? 'landscape' : 'portrait',
        unit: 'mm',
        format: [pdfWidth, pdfHeight]
      });
      
      // Add image to PDF - using exact dimensions
      pdf.addImage(imgData, 'PNG', 0, 0, pdfWidth, pdfHeight);
      
      // Save the PDF
      pdf.save(`${businessName.replace(/\s+/g, '_')}_Catalog.pdf`);
    } catch (error) {
      console.error("Error generating PDF:", error);
      throw error;
    }
  };
  return (
    <div className="md:min-h-screen flex flex-col bg-white">
      {/* Hidden element for PDF generation */}
      <div className="hidden">
        <div ref={pdfRef} className="p-8 bg-white text-black">
          <h1 className="text-2xl font-bold mb-4">{businessName} Catalog</h1>
          <p className="mb-2">{address}</p>
          
          <h2 className="text-xl font-bold mb-4">CONTENTS</h2>
          <ul className="list-disc list-inside mb-6">
            {products.map((item, index) => (
              <li key={index} className="mb-1">{item}</li>
            ))}
          </ul>
          
          <div className="mb-6">
            <h3 className="text-lg font-bold">{catalogueTitle}</h3>
            <h4 className="text-2xl font-bold">{catalogueSubtitle}</h4>
            <p className="italic">{catalogueTagline}</p>
          </div>
          <div className="text-center my-6">
      <h2 className="text-3xl font-bold">{cataloguePrice}</h2>
    </div>
    
          <div className="grid grid-cols-3 gap-4 mb-6">
            {thumbnails.map((src, idx) => (
              <img key={idx} src={src} alt={`Product ${idx + 1}`} className="w-full h-auto" />
            ))}
          </div>
          
          <p className="text-sm text-gray-500 mt-8">
            Generated from {window.location.origin} on {new Date().toLocaleDateString()}
          </p>
        </div>
      </div>
   <div className="md:px-12 px-4 md:pt-4 pt-2 md:mb-8 mb-2">
   <h1 className="text-[12px] md:text-4xl lg:text-[36px] font-bold mb-4">
   Farm Tools (Software)
      </h1>

       {/* Buttons Row */}
       <div className="grid grid-cols-7 gap-1 md:gap-2 w-full mb-4 md:mb-8">
  {buttons.map((btn, index) => (
    <button
      key={index}
      onClick={() => navigate(btn.path)}
      className={`
        h-4 md:h-10 lg:h-[40px] 
        rounded-[2px] shadow-md 
        text-[4px] md:text-sm lg:text-[14px] font-normal
        bg-[#152C24] text-white
        border-b-2 
        ${
          activeButton === index
            ? "border-[#FDBD26]"
            : "border-gray-400"
        }
        hover:bg-[#1a3a30] transition-colors duration-200
      `}
    >
      {btn.label}
    </button>
  ))}
</div>

      {/* Section Heading */}
      <h2 className="text-[10px] md:text-2xl lg:text-[24px] font-normal mb-1 md:mb-4">
        <span className="font-bold">Catalogues</span> 
      </h2>

      {/* Paragraph */}
      <p className="text-[6px] md:text-lg lg:text-[24px] font-normal mb-5 md:mb-10">
      Farming software tools are digital platforms designed to help farmers manage their operations more efficiently and profitably....
      </p>
          <div className="flex justify-between items-center  ">
  <h1 className="md:text-4xl text-xs font-bold md:mb-3 mb-1">REGISTRATION</h1>
    <a href="/Document">
            <div>
            <h1 className="md:text-[20px] font-bold mb-1 text-[6px]">SHARE CATALOGUE</h1>
              {renderButtonWithIcon("SHARE", "#152C24", "#FDBB26", true)}
              <p className="md:text-[14px] text-[4px] font-normal mt-1">Click to share catalogue</p>
            </div>
          </a>
  </div>


{/* Add the Catalog List Modal */}
<CatalogListModal
  isOpen={showCatalogList}
  onClose={() => setShowCatalogList(false)}
  catalogs={userCatalogs}
  onCatalogSelect={loadCatalog}
  onNewCatalog={handleNewCatalog}
/>

{/* Display current catalog URL when saved */}
{isSaved && catalogUrl && (
  <div className="mb-4 p-3 bg-green-50 border border-green-200 rounded-lg">
    <div className="flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-green-800">Your catalog is saved!</p>
        <p className="text-xs text-green-600 mt-1 break-all">
          Permanent URL: <a href={catalogUrl} target="_blank" rel="noopener noreferrer" className="underline">{catalogUrl}</a>
        </p>
      </div>
      <button
        onClick={() => navigator.clipboard.writeText(catalogUrl)}
        className="bg-green-100 text-green-800 px-3 py-1 rounded text-sm hover:bg-green-200 transition-colors"
      >
        Copy URL
      </button>
    </div>
  </div>
)}
   </div>
      <main className="relative flex-grow w-full text-white">
        {/* Background image or color */}
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ 
            backgroundColor: backgroundImage ? 'transparent' : '#D9D9D9',
            backgroundImage: backgroundImage ? `url(${backgroundImage})` : 'none'
          }}
        />
        
        {/* Add background image button */}
        <div className="absolute top-4 right-2 md:right-10 z-20">
          <label htmlFor="bg-upload" className="cursor-pointer">
            <img
              src={ADD_ICON}
              alt="Add background"
              className="w-[20px] h-[20px] md:w-[40px] md:h-[40px]"
            />
            <input
              id="bg-upload"
              type="file"
              accept="image/*"
              className="hidden"
              onChange={(e) => handleBackgroundUpload(e.target.files[0])}
            />
          </label>
        </div>

        {/* Soft gradient to improve contrast on text */}

        {/* Canvas padding */}
        <div className="relative z-10 px-4 md:px-12 py-4 lg:py-6">
          {/* Top row */}
          <div className="flex flex-row items-start justify-between gap-4 md:pt-14 pt-2 md:gap-6">
            {/* Left: Logo + Address block */}
            <div className="flex flex-col gap-4 w-full md:w-auto">
              <img
                src={LOGO}
                alt="MyHUSTLE"
                className="w-[100px] md:w-[250px] -ml-4 md:-ml-2 h-[25px] md:h-[85px] object-contain"
              />

           {/* Address + WhatsApp */}
<div>
  <div>
    <h1 
      className="text-[10px] md:text-[24px] font-medium leading-tight bg-transparent border-none outline-none"
      contentEditable={!isSaved}
      suppressContentEditableWarning
      onBlur={(e) => {
        setBusinessName(e.target.textContent);
        setIsSaved(false);
      }}
    >
      {businessName}
    </h1>
    <p 
      className="mt-1 text-[8px] md:text-[14px] font-medium leading-[1.1] whitespace-pre-line bg-transparent border-none outline-none"
      contentEditable={!isSaved}
      suppressContentEditableWarning
      onBlur={(e) => {
        setAddress(e.target.textContent);
        setIsSaved(false);
      }}
    >
      {address}
    </p>
    
    {/* Star + Input Field */}
    <div className="flex items-center gap-6 mt-2">
      <img
        src="https://res.cloudinary.com/dwfdzdaxk/image/upload/v1759171006/Vector_kvljwr.png"
        alt="star"
        className="w-[12px] h-[12px] md:w-[22px] md:h-[22px] object-contain"
      />
      <input
        type="text"
        placeholder="-"
        className="bg-transparent border-none outline-none text-[#979797] font-bold text-[16px] md:text-[24px] w-full"
        onFocus={(e) => {
          if (e.target.value === '') {
            e.target.value = '';
          }
        }}
        onBlur={(e) => {
          if (e.target.value === '') {
            e.target.placeholder = '-';
          }
        }}
      />
    </div>
  </div>
  
  <div className="flex items-center gap-1 md:gap-2 ">
    <img
      src={WHATSAPP}
      alt="WhatsApp"
      className="w-[20px] md:w-[35px] h-[20px] md:h-[35px] object-contain mt-3 md:mt-4"
    />
    <h1 className="md:text-[24px] text-[8px] font-bold text-white">Buy Now</h1>
  </div>
</div>
              {/* 44x44 icon below logo - only show when saved */}
              {isSaved && (
                <img
                  src={ICON_CHEVRON}
                  alt="icon"
                  className="w-[26px] md:w-[44px] h-[26px] md:h-[44px] mt-2 -ml-1 md:-ml-2 object-contain"
                />
              )}
            </div>

            {/* Right: Split button + Contents list */}
            <div className="flex flex-col items-start gap-4 md:gap-6 w-[200px] md:w-[300px] mt-6 md:mt-8">
          

              {/* Contents */}
              <div className="flex items-start gap-4 md:gap-6 w-full relative">
                {/* White line - only show when saved */}
                {isSaved && (
                  <div className="w-[4px] md:w-[6px] h-[250px] md:h-[550px] bg-white/90" />
                )}
              <div className="md:w-[300px] w-[140px]">
              <div className="flex-grow bg-black/30 pl-2 md:pl-5 p-2 rounded">
                  <div className="flex justify-between items-center mb-2  md:mb-4">
                    <div className="text-[10px] md:text-[28px] lg:text-[32px] font-bold tracking-wide">
                      CONTENTS
                    </div>
                    {!isSaved && (
                      <img
                        src={EDIT_ICON}
                        alt="Edit products"
                        className="w-[16px] h-[16px] md:w-[24px] md:h-[24px] cursor-pointer"
                        onClick={handleProductEdit}
                      />
                    )}
                  </div>
                  <ul className="space-y-1 md:space-y-5">
                    {products.map((item, index) => (
                      <li 
                        key={index} 
                        className="text-[6px] md:text-[24px] italic bg-transparent border-none outline-none"
                        contentEditable={!isSaved}
                        suppressContentEditableWarning
                        onBlur={(e) => handleProductChange(index, e.target.textContent)}
                      >
                        {isEditingProducts && (index === 0 || index === products.length - 1) ? "XXXXXX" : item}
                      </li>
                    ))}
                  </ul>
                  
                  {/* Hint text and Delete button at the bottom of the content box */}
                
                </div>
                {!isSaved && (
                  <div className="flex justify-between items-center mt-1 md:mt-1 pt-2">
                    <div className="text-white text-[6px] md:text-[14px] font-normal">
                      Type on the sections
                    </div>
                    <div className="flex items-center gap-1 cursor-pointer" onClick={handleDelete}>
                      <img
                        src={DELETE_ICON}
                        alt="Delete"
                        className="w-[16px] h-[16px] md:w-[24px] md:h-[24px]"
                      />
                      <span className="text-white text-[6px] md:text-[16px]">Delete</span>
                    </div>
                  </div>
                )}
              </div>
              </div>

            </div>
          </div>

          {/* Spacer to push bottom row near page bottom on large screens */}
          <div className="h-2 sm:h-16 md:h-24 lg:h-32" />

          {/* Bottom row: headings + button */}
          <div className="flex :flex-row items-end justify-between gap-4 md:gap-6 mt-3 md:mt-0">
            {/* Left texts */}
            <div>
              <div 
                className="text-[10px] md:text-[32px] font-semibold leading-none bg-transparent border-none outline-none"
                contentEditable={!isSaved}
                suppressContentEditableWarning
                onBlur={(e) => {
                  setCatalogueTitle(e.target.textContent);
                  setIsSaved(false);
                }}
              >
                {catalogueTitle}
              </div>
              <div 
                className="text-[8px] md:text-[48px] font-bold leading-none mt-1 md:mt-2 bg-transparent border-none outline-none"
                contentEditable={!isSaved}
                suppressContentEditableWarning
                onBlur={(e) => {
                  setCatalogueSubtitle(e.target.textContent);
                  setIsSaved(false);
                }}
              >S
                {catalogueSubtitle}
              </div>
              <div 
                className="text-[6px] md:text-[24px] italic mt-1 md:mt-2 bg-transparent border-none outline-none"
                contentEditable={!isSaved}
                suppressContentEditableWarning
                onBlur={(e) => {
                  setCatalogueTagline(e.target.textContent);
                  setIsSaved(false);
                }}
              >
                {catalogueTagline}
              </div>
            </div>

            {/* Right button */}
            <div className="mt-4 md:mt-0 md:self-end">
              <SplitButtonBottom onSave={handleSave} isSaved={isSaved} onShare={handleShare} />
            </div>
          </div>

          {/* Big text heading in center of the gray box */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
  <div 
    className="text-white text-[18px] md:text-[64px] font-bold text-center bg-transparent border-none outline-none"
    contentEditable={!isSaved}
    suppressContentEditableWarning
    onBlur={(e) => {
      setCataloguePrice(e.target.textContent);
      setHasChanges(true);
    }}
    style={{ pointerEvents: !isSaved ? 'auto' : 'none' }}
  >
    {cataloguePrice}
  </div>
</div>

        </div>

        {/* Custom styles for Slick slider - removed arrow styles */}
        <style>{`
          .slick-custom .slick-dots {
            bottom: -35px;
          }
          
          .slick-custom .slick-dots li button:before {
            font-size: 12px;
            color: white;
            opacity: 0.5;
          }
          
          .slick-custom .slick-dots li.slick-active button:before {
            opacity: 1;
            color: #FDBB26;
          }
          
          @media (max-width: 768px) {
            .slick-custom .slick-dots {
              bottom: -30px;
            }
          }
        `}</style>
      </main>
      
      {/* Thumbnails slider positioned below the main content */}
  {/* Thumbnails slider positioned below the main content */}
  <div className="pb-4 md:pb-2  p-2 md:p-4 bg-[#E7EBEB]">
  <Slider {...sliderSettings} className="slick-custom">
    {thumbnails.map((src, idx) => (
      <div key={idx} className="focus:outline-none px-1 md:px-2">
        <div className="relative">
          <label htmlFor={`thumb-upload-${idx}`} className="cursor-pointer">
            <div 
              className="h-[60px] md:h-[195px] overflow-hidden relative"
              style={{ backgroundColor: '#D9D9D9' }}
            >
              {src && src !== DEFAULT_THUMB ? (
                <img
                  src={src}
                  alt={`thumb-${idx}`}
                  className="w-full h-full object-cover"
                />
              ) : (
                <div className="w-full h-full flex items-center justify-center bg-[#D9D9D9]" />
              )}

              {/* Icons */}
              {!isSaved && (
                <div className="absolute inset-0">
                  {/* Add/Upload Icon (Top Right) */}
                  <label 
                    htmlFor={`thumb-upload-${idx}`} 
                    className="absolute md:top-2  right-1 top-1 md:right-2 cursor-pointer"
                  >
                    <img
                      src={ADD_ICON}
                      alt="Upload"
                      className="w-[12px] md:w-[34px]  h-[12px] md:h-[34px] object-contain"
                    />
                  </label>

                  {/* Delete Icon (Bottom Right) - Only show if image is uploaded */}
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        const newThumbnails = [...thumbnails];
                        newThumbnails[idx] = DEFAULT_THUMB;
                        setThumbnails(newThumbnails);
                        setIsSaved(false);
                      }}
                      className="absolute bottom-1 md:bottom-2 right-1 md:right-2 cursor-pointer"
                    >
                      <img
                        src={DELETE_ICON}
                        alt="Delete"
                        className="w-[13px] md:w-[34px] h-[12px] md:h-[34px] object-contain"
                      />
                    </button>
                </div>
              )}
            </div>
            
            {/* Hidden file input */}
            {!isSaved && (
              <input
                id={`thumb-upload-${idx}`}
                type="file"
                accept="image/*"
                className="hidden"
                onChange={(e) => {
                  if (e.target.files && e.target.files[0]) {
                    handleThumbnailUpload(idx, e.target.files[0]);
                  }
                }}
              />
            )}
          </label>
        </div>
      </div>
    ))}
  </Slider>
</div>
      {isLoading && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-4 rounded-lg flex items-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mr-3"></div>
      <span>Saving your catalog...</span>
    </div>
  </div>
)}
{isLoadingExisting && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
    <div className="bg-white p-4 rounded-lg flex items-center">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500 mr-3"></div>
      <span>Loading your catalog...</span>
    </div>
  </div>
)}
<ShareModal
  isOpen={isShareModalOpen}
  onClose={() => setIsShareModalOpen(false)}
  shareLink={shareLink}
  businessName={businessName}
  onDownloadPDF={generatePDF} // Add this line
/>
    </div>
  );
}